import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    categoryList: null,
    allConfigFile: [],
    configFileData: [],
  },
  getters: {
    categoryList: (state) => state.categoryList,
    allConfigFile: (state) => state.allConfigFile,
    configFileData: (state) => state.configFileData,
    listOfRule: (state) => state.listOfTest,
  },
  actions: {
    loadModelCategory(context, modelID) {
      return new Promise((resolve, reject) => {
        alice
          .loadModelCategory(modelID)
          .then((response) => {
            context.commit('setModelCategoryData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllConfigFile(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllConfigFile()
          .then((response) => {
            context.commit('setAllConfigFileData', response.data.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getConfigFile(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .getConfigFile(configId)
          .then((response) => {
            context.commit('setConfigFileData', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createConfigFile(context, params) {
      const configData = params;
      return new Promise((resolve, reject) => {
        alice
          .createConfigFile(configData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateConfigFile(context, params) {
      const { configId, configData } = params;
      return new Promise((resolve, reject) => {
        alice
          .updateConfigFile(configId, configData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteConfigFile(context, configId) {
      return new Promise((resolve, reject) => {
        alice
          .deleteConfigFile(configId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setModelCategoryData(state, data) {
      Vue.set(state, 'categoryList', data);
    },
    setAllConfigFileData(state, data) {
      Vue.set(state, 'allConfigFile', data);
    },
    setConfigFileData(state, data) {
      Vue.set(state, 'configFileData', data);
    },
  },
};
